import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import LoginLogo from '../../Assets/images/Frame 39059 1.png';
import LoginImg from '../../Assets/images/Loginimage-woman-smile-happy-joy 1.png';
import BackgroundImage from '../../Assets/images/LoginAndSignUpBG.png';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../../config';
const NewPassword = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordReTypeVisible, setPasswordReTypeVisible] = useState(false);

  // Initialize state with values from sessionStorage
  const [password, setPassword] = useState(
    () => sessionStorage.getItem('password') || ''
  );
  const [ReTypepassword, setReTypepassword] = useState(
    () => sessionStorage.getItem('reTypePassword') || ''
  );

  // Update sessionStorage whenever state changes
  useEffect(() => {
    sessionStorage.setItem('password', password);
  }, [password]);

  useEffect(() => {
    sessionStorage.setItem('reTypePassword', ReTypepassword);
  }, [ReTypepassword]);

  const handleLoginClick = () => navigate('/login');

  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
  const toggleReTypePasswordVisibility = () =>
    setPasswordReTypeVisible(!passwordReTypeVisible);

const validateForm = () => {
  const newErrors = {};
  if (!password) newErrors.password = 'Password is required';
  if (!ReTypepassword)
    newErrors.ReTypepassword = 'Re-Type Password is required';

  // Return the errors object
  return newErrors;
};

const handleNewPassword = async () => {
  const validationErrors = validateForm(); // Now this will return the errors
  if (Object.keys(validationErrors).length === 0) {
    try {
      const signUpData = {
        password,
        confirm_password: ReTypepassword,
      };

      const response = await axios.post(
        `${API_BASE_URL}/account/save-password/`,
        // 'https://finwise-backend.vercel.app/account/save-password/',
        // 'https://finwiseback.finwise.com.bd/account/save-password/',
        // 'http://127.0.0.1:8000/account/save-password/',
        signUpData,
        {
          headers: {
            'Content-Type': 'application/json',
            Cookie: 'sessionid=vonpwnmq5904ndb7w395ect6tmgzey2r',
          },
          withCredentials: true,
        }
      );

      // console.log(response.data.non_field_errors[0]);
      Swal.fire({
        // icon: 'success',
        title: 'Success!',
        text: 'Success! Please Login!',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });

      navigate('/login');
    } catch (error) {
      if (error.response) {
        console.error('Password Reset error:', error.response.data);
        if (error.response.status === 400) {
          Swal.fire({
            // icon: 'warning',
            title: 'Password Reset failed!',
            text: 'Password incorrect.',
            customClass: {
              popup: 'w-72 h-auto p-3',
              title: 'text-lg',
              content: 'text-xs',
              confirmButton:
                'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
            },
          });
        } else {
          Swal.fire({
            // icon: 'error',
            title: 'Error!',
            text: 'Something went wrong. Please try again later.',
            customClass: {
              popup: 'w-72 h-auto p-3',
              title: 'text-lg',
              content: 'text-xs',
              confirmButton:
                'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
            },
          });
        }
      } else {
        console.error('Password Reset error:', error.message);
        Swal.fire({
          // icon: 'error',
          title: 'Error!',
          text: 'Network error. Please check your connection.',
          customClass: {
            popup: 'w-72 h-auto p-3',
            title: 'text-lg',
            content: 'text-xs',
            confirmButton:
              'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
          },
        });
      }
    }
  } else {
    setErrors(validationErrors); // Set validation errors in the state
  }
};


  const handleSignUpKey = e => {
    if (e.key === 'Enter') handleNewPassword();
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen md:py-0 py-2 md:mt-16 mt-20"
      style={{ backgroundImage: `url(${BackgroundImage})` }}
    >
      <div className="bg-white md:p-4 p-8 lg:pl-10 lg:pr-10 gap-10 shadow-xl rounded-xl">
        {/* top secton */}
        <div className="items-center justify-center flex">
          <img
            src={LoginLogo}
            alt="LoginLogo"
            className="md:h-16 h-10 lg:h-16 mb-0 pr-10 lg:mb-1"
          />
        </div>
        <h2 className="items-center justify-center flex lg:font-bold lg:mb-5 text-xs lg:text-sm">
          Trade and Finance Solutions
        </h2>

        <div className="items-center justify-center flex flex-col lg:flex-row gap-16">
          {/* left section */}
          <div className="lg:block hidden">
            <img
              src={LoginImg}
              alt="LoginImg"
              className="md:h-40 h-32 lg:h-44"
            />
          </div>

          {/* right section */}
          <div>
            <h2 className="text-xl text-center lg:text-2xl font-semibold mt-1 mb-4 heading">
              Forget Password
            </h2>

            <div className="w-full lg:w-[400px] space-y-4 mt-2 text-xs">
              {/* Input Fields */}
              <div className="flex flex-col space-y-4">
                <div className="relative w-full">
                  <input
                    type={passwordVisible ? 'text' : 'password'}
                    placeholder="Password"
                    className="border border-gray-300 rounded-md py-2 px-4 w-full"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    onKeyDown={handleSignUpKey}
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none"
                  >
                    {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                    <span className="ml-1 text-sm">
                      {passwordVisible ? 'Hide' : 'Show'}
                    </span>
                  </button>
                </div>
                {errors.password && (
                  <p className="text-red-500 text-xs mb-0 -mt-2">
                    {errors.password}
                  </p>
                )}

                <div className="relative w-full">
                  <input
                    type={passwordReTypeVisible ? 'text' : 'password'}
                    placeholder="Re-Type Pass"
                    className="border border-gray-300 rounded-md py-2 px-4 w-full"
                    value={ReTypepassword}
                    onChange={e => setReTypepassword(e.target.value)}
                    onKeyDown={handleSignUpKey}
                  />
                  <button
                    type="button"
                    onClick={toggleReTypePasswordVisibility}
                    className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none"
                  >
                    {passwordReTypeVisible ? <FaEyeSlash /> : <FaEye />}
                    <span className="ml-1 text-sm">
                      {passwordReTypeVisible ? 'Hide' : 'Show'}
                    </span>
                  </button>
                </div>
                {errors.ReTypepassword && (
                  <p className="text-red-500 text-xs mb-0 -mt-2">
                    {errors.ReTypepassword}
                  </p>
                )}
              </div>
              <button
                onClick={handleNewPassword}
                className="w-full bg-orange-300 text-white py-2 px-6 hover:bg-btnHover mb-2 mt-2 font-bold rounded-2xl"
              >
                Submit
              </button>

              {/* Already have an account? */}
              <p className="mb-0 text-center text-xs text-gray-600">
                Already have an account?
                <button onClick={handleLoginClick} className="underline ml-2">
                  Login
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPassword;
